"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const index_1 = require("../../../index");
const Message = (props) => {
    const { form, message, onClick, type, title, fillWidth = false, } = props;
    const messageIcon = () => {
        switch (type) {
            case 'error':
                return 'excl_red';
            case 'warn':
                return 'excl_orange';
            case 'success':
                return 'check_green';
            default:
                return 'info_blue';
        }
    };
    return (React.createElement("div", { className: classnames_1.default({
            'form-message': form,
            'message': !form,
            [`message-${type}`]: !!type,
            'message-fill-width': fillWidth,
        }) },
        !form && React.createElement(index_1.Icon, { icon: messageIcon(), className: "message-icon" }),
        React.createElement("div", { className: "message-body" },
            title && (React.createElement(React.Fragment, null,
                React.createElement("p", { className: 'message-title' },
                    React.createElement("b", null, title)))),
            message),
        !!onClick && (React.createElement("button", { type: "button", className: "close", "data-dismiss": type, "aria-label": "Close", "aria-hidden": "true", onClick: onClick },
            React.createElement(index_1.Icon, { icon: "cross" })))));
};
exports.default = Message;
//# sourceMappingURL=Message.js.map